<h2>Let's Add Your Changes</h2>
<form [formGroup]="form">
  <div class="input-container">
    <label>Purpose of Change </label>

    <mat-form-field appearance="outline">
      <textarea
        formControlName="changeReason"
        matInput
        placeholder="Description of change requested and reason for change (provide detailed explanation of why the change is requested)"
        matTextareaAutosize
        matAutosizeMinRows="9"
        matAutosizeMaxRows="9"
      ></textarea>
      <mat-error *ngIf="errorHandling('changeReason', 'required')">
        Purpose of Change is <strong>Required</strong>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="column-2">
    <div class="col">
      <div class="input-container">
        <label>Estimated Volume Increase </label>

        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="If a range, enter the higher number "
            formControlName="volumeIncrease"
          />
          <mat-error *ngIf="errorHandling('volumeIncrease', 'pattern')">
            Please enter integer value
          </mat-error>
          <mat-error *ngIf="errorHandling('volumeIncrease', 'max')">
            Value must be less than or equal to 999999
          </mat-error>
        </mat-form-field>
      </div>
      <div class="input-container">
        <label>Unit of Measure</label>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-select formControlName="unitOfMeasure">
            <mat-option
              *ngFor="let option of streamOptions.options"
              [value]="option"
            >
              {{ option }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="errorHandling('unitOfMeasure', 'required')">
            Unit of Measure is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="input-container">
        <label> Extends Expiration </label>
        <mat-form-field appearance="outline">
          <input
            matInput
            [matDatepicker]="picker"
            [min]="today"
            formControlName="expiryDate"
          />
          <mat-datepicker-toggle
            matPrefix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="input-container">
        <label>Generator Name Change (Optional)</label>
        <mat-form-field appearance="outline">
          <input
            maxlength="64"
            matInput
            formControlName="generatorName"
            [tabIndex]="3"
          />
          <mat-error *ngIf="errorHandling('generatorName', 'required')">
            Generator Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col">
      <div class="input-container">
        <label>Other (optional)</label>

        <mat-form-field appearance="outline">
          <textarea
            formControlName="otherChanges"
            matInput
            matTextareaAutosize
            matAutosizeMinRows="8"
            matAutosizeMaxRows="8"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div>
    <digital-platform-address-input
      label="Generator Mailing Address Change (Optional)"
      formControlName="generatorAddress"
      [tabIndex]="16"
      [required]="false"
    ></digital-platform-address-input>
  </div>
</form>
